import { Edit as EditOrder } from './Edit';

export default EditOrder;
